// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1eEO7","label":"Labeled_label__xKrCZ","divider":"Labeled_divider__3mRgc"};